//state
const state = {
  // axios message
  axios_message: ''
}

//mutations
const mutations = {
  // axios error
  A_ERROR(state, data) {
    if (data.error.reason) {
      state.axios_message = data.error.reason
    } else {
      let error = data.error.validation_error
      for (const prop in error) {
        if (Object.hasOwn(error, prop)) {
          state.axios_message = `${error[prop]}`
        }
      }
    }
  },
  A_CLEAR(state, data) {
    state.axios_message = data
  }
}

//actions
const actions = {
  //axios error
  A_error({ commit }, data) {
    commit('A_ERROR', data)
  },
  A_clear({ commit }, data) {
    commit('A_CLEAR', data)
  }
}

export default {
  namespaced: true, //namespaced
  state,
  mutations,
  actions
}
